export function getShowOverlay (state) {
  return state.server.showOverlay
}

export function getOverlayMessage (state) {
  return state.server.overlayMessage
}

export function getOverlayFunction (state) {
  return state.server.overlayFunction
}



//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/store/modules/httpRequests/getters.js
// module id = null
// module chunks = 